angular.module("tcMailgun").provider("tcMailgun", mailgunProvider);

function mailgunProvider() {
  var config = {
    url: "https://api.mailgun.net/v2/address/validate",
    key: null,
  };

  this.setup = function (params) {
    config = Object.assign({}, config, params);
  };

  this.$get = function () {
    return Object.assign({}, config);
  };
}
